export { default } from './Flag.js';
